import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import * as DOMPurifyImport from 'dompurify';
import { getCookie, setCookie } from '../utils/cookie';
import './MarketingPopup.scss';
// Egységesen kezeljük az ESM/CJS interop esetét: néhány bundler default export-ban
// adja a DOMPurify-t, mások namespace-ben — itt mindkettő működik.
const DOMPurify = 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(DOMPurifyImport.default || DOMPurifyImport);
// Cookie név: NEM 'jobboard-popup-visible' (a régi PHP használta), mert sok ad-/tracker-blocker
// pont ezen a néven szűr. Új név: cs_popup_seen → career site popup seen.
const COOKIE_NAME = 'cs_popup_seen';
const SHOW_DELAY_MS = 800;
const SANITIZE_CONFIG = {
    ADD_ATTR: ['style', 'target', 'rel'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|ftp):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
};
export function MarketingPopup({ popup }) {
    const [isOpen, setIsOpen] = useState(false);
    const timerRef = useRef(null);
    // Mount: 800ms után nyissunk, ha nincs cookie
    useEffect(() => {
        if (!popup.visible)
            return;
        if (getCookie(COOKIE_NAME) === 'true')
            return;
        timerRef.current = window.setTimeout(() => {
            setIsOpen(true);
        }, SHOW_DELAY_MS);
        return () => {
            if (timerRef.current !== null) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [popup.visible]);
    // ESC + body scroll lock — csak amíg nyitva van
    useEffect(() => {
        if (!isOpen)
            return;
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };
        document.addEventListener('keydown', handleEscape);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = prevOverflow;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    const handleClose = () => {
        setCookie(COOKIE_NAME, 'true', popup.cookie_days);
        setIsOpen(false);
    };
    const handleConfirm = () => {
        setCookie(COOKIE_NAME, 'true', popup.cookie_days);
        const url = (popup.confirm.url || '').trim();
        if (url) {
            // Redirect a teljes oldalra; a cookie már mentve, így a célból visszatérve sem nyílik újra
            window.location.href = url;
            return;
        }
        setIsOpen(false);
    };
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };
    if (!isOpen)
        return null;
    const sanitizedContent = DOMPurify.sanitize(popup.content, SANITIZE_CONFIG);
    const hasConfirm = popup.confirm.text.trim() !== '';
    const hasCancel = popup.cancel.text.trim() !== '';
    return (_jsx("div", { className: "career-popup-overlay", onClick: handleOverlayClick, children: _jsxs("div", { className: "career-popup", role: "dialog", "aria-modal": "true", "aria-label": "Marketing pop-up", children: [_jsx("button", { type: "button", className: "career-popup-close", onClick: handleClose, "aria-label": "Bez\u00E1r\u00E1s", children: _jsx("i", { className: "fa fa-times", "aria-hidden": "true" }) }), _jsx("div", { className: "career-popup-content", dangerouslySetInnerHTML: { __html: sanitizedContent } }), (hasConfirm || hasCancel) && (_jsxs("div", { className: "career-popup-footer", children: [hasConfirm && (_jsx("button", { type: "button", className: "career-popup-btn career-popup-btn-confirm", onClick: handleConfirm, children: popup.confirm.text })), hasCancel && (_jsx("button", { type: "button", className: "career-popup-btn career-popup-btn-cancel", onClick: handleClose, children: popup.cancel.text }))] }))] }) }));
}
export default MarketingPopup;
